<ng-template #noRoles>
  <div class="m-4">Please select a role in the sidebar.</div>
</ng-template>

<div class="d-flex">
  <div class="sidebar-content px-4">
    <div class="card mt-4">
      <div class="card-header">
        <h3>Activation</h3>
        <fa-icon class="card-header-icon bg-gradient-primary text-white" icon="toggle-on" size="lg" [fixedWidth]="true"></fa-icon>
      </div>
      <div class="card-body">
        <app-chat-activation-table [root]="root"></app-chat-activation-table>
      </div>
    </div>

    <div class="card my-4">
      <div class="card-header">
        <h3>Permissions</h3>
        <fa-icon class="card-header-icon bg-gradient-primary text-white" icon="key" size="lg" [fixedWidth]="true"></fa-icon>
      </div>
      <div *ngIf="selected.length else noRoles" class="card-body">
        <app-permission-table
          [roles]="selected"
          [subject]="chatSubject"
          [protectRoles]="['api']"
          [resources]="false"
        ></app-permission-table>
      </div>
    </div>
  </div>

  <div class="sidebar-right p-3">
    <app-role-sidebar [roles]="roles" [(selected)]="selected"></app-role-sidebar>
  </div>
</div>
